import { CONFERENCE_JOINED } from '../../../react/features/base/conference/actionTypes';
import { KIBANA_MESSAGES } from './kibana/constants';
export function createVisitorEvent({ buttonName, attributes = {}, source }) {
    return {
        action: 'clicked',
        actionSubjectId: buttonName,
        actionSubject: buttonName,
        attributes,
        source,
        subject: KIBANA_MESSAGES.Visitors,
        type: 'ui'
    };
}
export function createConferenceJoinedEvent(eventData) {
    return {
        subject: CONFERENCE_JOINED,
        ...eventData
    };
}
